import GaDivider from './GaDivider'

export default GaDivider
